import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/services/base.service';


@Component({
    selector: 'app-season-manager',
    templateUrl: './season-manager.component.html',
    styleUrls: ['./season-manager.component.css'],
    standalone: false
})
export class SeasonManagerComponent extends BaseService implements OnInit {




  constructor(public router: Router, private activatedRoute: ActivatedRoute) {
    super();
  }
  ngOnInit(): void {
  }


}

